import React, { createContext, useEffect, useState } from 'react';
import { WelcomeScreenSchema, WelcomeScreenProps } from '../../schema';

export const DataContext = createContext<WelcomeScreenProps>({
  account_name: '',
  account_small_logo: '',
  aggregate_id: '',
  confidentiality_content: {
    message: '',
    subject: '',
  },
  product_type: '',
  privacy_policy: '',
  raw_data_extract_warning: '',
  secret: '',
  start_path: '',
  survey_logo: null,
  survey_name: '',
  supported_locales: [
    {
      name: '',
      code: '',
    },
  ],
  threesixty_name: '',
  welcome_screen_locale: {
    name: '',
    code: '',
  },
  welcome_content: '',
});

export const LayoutContext = createContext<boolean>(true);

export const WelcomeScreenDataProvider = ({
  children,
  props,
}: {
  children: JSX.Element;
  props: WelcomeScreenProps;
}) => {
  const welcomeScreenProps = WelcomeScreenSchema.parse(props);
  const [data, setData] = useState<WelcomeScreenProps>(welcomeScreenProps);

  // While the data does not update for the welcome screen on the frontend, this hook is required for storybook.
  useEffect(() => {
    setData(welcomeScreenProps);
  }, [welcomeScreenProps]);

  return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
};
